import { franc } from 'franc-min';
import langs from 'langs';

const MIN_TEXT_LENGTH = 5;

const getSampleText = (segments, field) => {
  if (!Array.isArray(segments)) return '';
  const parts = segments
    .map((segment) => (segment?.[field] || '').trim())
    .filter(Boolean)
    .slice(0, 5);
  return parts.join(' ');
};

export const detectLanguageCode = (text) => {
  if (!text || text.trim().length < MIN_TEXT_LENGTH) {
    return null;
  }
  const code3 = franc(text, { minLength: MIN_TEXT_LENGTH });
  if (!code3 || code3 === 'und') {
    return null;
  }
  const lang = langs.where('3', code3);
  return lang?.['1'] || null;
};

export const detectLanguagesFromSegments = (segments) => {
  const sourceText = getSampleText(segments, 'source');
  const targetText = getSampleText(segments, 'target');

  return {
    source: detectLanguageCode(sourceText),
    target: detectLanguageCode(targetText),
  };
};
